"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultGetTheGraphClient = exports.getTheGraphNearClient = exports.getTheGraphEvmClient = exports.getTheGraphClient = void 0;
const currency_1 = require("@requestnetwork/currency");
const graphql_request_1 = require("graphql-request");
const graphql_1 = require("./generated/graphql");
const graphql_near_1 = require("./generated/graphql-near");
const lodash_1 = require("lodash");
const HOSTED_THE_GRAPH_URL = 'https://api.thegraph.com/subgraphs/name/requestnetwork/request-payments-';
const THE_GRAPH_URL_MANTLE_TESTNET = 'https://graph.testnet.mantle.xyz/subgraphs/name/requestnetwork/request-payments-mantle-testnet';
const THE_GRAPH_URL_MANTLE = 'https://graph.fusionx.finance/subgraphs/name/requestnetwork/request-payments-mantle';
const THE_GRAPH_URL_STUDIO_ZKSYNC = 'https://api.studio.thegraph.com/query/35843/request-payment-zksyncera/version/latest';
/** Splits the input options into "client options" to pass to the SDK, and "query options" to use in queries */
const extractClientOptions = (url, options) => {
    const optionsObject = options !== null && options !== void 0 ? options : {};
    // build query options
    const queryOptions = {};
    const { minIndexedBlock } = optionsObject;
    if (minIndexedBlock) {
        queryOptions.blockFilter = { number_gte: minIndexedBlock };
    }
    else if (url.match(/^https:\/\/gateway-\w+\.network\.thegraph\.com\//)) {
        // the decentralized network expects an empty object, and doesn't support "undefined"
        queryOptions.blockFilter = {};
    }
    // build client options
    const clientOptions = (0, lodash_1.omit)(optionsObject, 'minIndexedBlock');
    return [clientOptions, queryOptions];
};
const getTheGraphClient = (network, url, options) => currency_1.NearChains.isChainSupported(network)
    ? (0, exports.getTheGraphNearClient)(url, options)
    : (0, exports.getTheGraphEvmClient)(url, options);
exports.getTheGraphClient = getTheGraphClient;
const getTheGraphEvmClient = (url, options) => {
    const [clientOptions, queryOptions] = extractClientOptions(url, options);
    const sdk = (0, graphql_1.getSdk)(new graphql_request_1.GraphQLClient(url, clientOptions));
    sdk.options = queryOptions;
    return sdk;
};
exports.getTheGraphEvmClient = getTheGraphEvmClient;
const getTheGraphNearClient = (url, options) => {
    const [clientOptions, queryOptions] = extractClientOptions(url, options);
    const sdk = (0, graphql_near_1.getSdk)(new graphql_request_1.GraphQLClient(url, clientOptions));
    sdk.options = queryOptions;
    return sdk;
};
exports.getTheGraphNearClient = getTheGraphNearClient;
const defaultGetTheGraphClient = (network, options) => {
    return network === 'private'
        ? undefined
        : currency_1.NearChains.isChainSupported(network)
            ? (0, exports.getTheGraphNearClient)(`${HOSTED_THE_GRAPH_URL}${network.replace('aurora', 'near')}`, options)
            : network === 'mantle'
                ? (0, exports.getTheGraphEvmClient)(THE_GRAPH_URL_MANTLE, options)
                : network === 'mantle-testnet'
                    ? (0, exports.getTheGraphEvmClient)(THE_GRAPH_URL_MANTLE_TESTNET, options)
                    : network === 'zksyncera'
                        ? (0, exports.getTheGraphEvmClient)(THE_GRAPH_URL_STUDIO_ZKSYNC, options)
                        : (0, exports.getTheGraphEvmClient)(`${HOSTED_THE_GRAPH_URL}${network}`, options);
};
exports.defaultGetTheGraphClient = defaultGetTheGraphClient;
